import {Routes} from './routes';

export const XSOLLA_TERMS_LINK = 'https://xsolla.com/terms-of-use';
export const XSOLLA_POLICIES_LINK = 'https://xsolla.com/privacypolicy/';
export const XSOLLA_LOGIN_SESSION_URL = window.location.origin + Routes.VERIFY;
export const XSOLLA_RESET_PASSWORD_LOGIN_URL = window.location.origin + Routes.LOGIN;
